import React from 'react';
import {Container} from "@mui/material";
import BackGround from "../BackGround/BackGround";
import {Button} from "antd";

const OurContacts = () => {
    {/* eslint-disable-next-line */}
    // ym(92960084,'reachGoal','ymContacts')
    // console.log('reachGoal_ymContacts');
    return (
        <>
            <BackGround/>
            <Container  maxWidth="xl">
                <div className={"myblurText1"}>
                    <h4 className={"paddingTop15"}>Контакты</h4>
                    <div className={"myfontABC"}>
                    <span>
                        <p>
                          <Button className={"unpadding"} target={"_blank"} href={"https://www.ozon.ru/seller/gobananas-2189062/products/?miniapp=seller_2189062"} style={{marginBottom: "5px"}} color="primary" variant="solid">
                                            НАШ МАГАЗИН НА OZON
                                        </Button>
                            </p>

                            <Button className={"unpadding"} target={"_blank"} href={"https://www.wildberries.ru/seller/1391479"} style={{marginBottom: "5px", background: "#a73afd"}}  variant="solid">
                                            НАШ МАГАЗИН НА WB
                                        </Button>
                          {/* <p className={"unpadding"}>   <a className={"myfontABC"}*/}
                          {/*                                  target="_blank"*/}
                          {/*                                  href={"https://www.ozon.ru/seller/gobananas-2189062/products/?miniapp=seller_2189062"}>НАШ МАГАЗИН НА OZON</a></p>*/}
                          {/*<p className={"unpadding"}>   <a className={"myfontABC"}*/}
                          {/*                                 href={"https://www.wildberries.ru/seller/1391479"}*/}
                          {/*                                 target="_blank"*/}
                          {/*>НАШ МАГАЗИН НА WB</a></p>*/}
                          <p className={"unpadding"}> ИП Лепченко Анна Сергеевна  </p>
                          <p className={"unpadding"}> ИНН: 771823715190 </p>
                           <p className={"unpadding"}>ОРГНИП: 324774600522951</p>
                          <p className={"unpadding"}>--</p>

                        Телефоны:
                             <p className={"unpadding"}>   <a className={"myfontABC"} href={"tel:+79163865050"}>+7 916 3865050</a></p>
                             <p className={"unpadding"}>   <a className={"myfontABC"} href={"tel:+79250385050"}>+7 925 0385050</a></p>
                        <p className={"unpadding"}> Email:  <a className={"myfontABC"}
                                                               href={"mailto:info@go-bananas.ru"}>info@go-bananas.ru</a></p>
                        {/*<p className={"unpadding"}> ВКонтакте:  <a className={"myfontABC"}*/}
                        {/*                                           href={"https://vk.com/go_bananas_ru"}>vk.com/go_bananas_ru</a></p>*/}
                        <p className={"unpadding"}> Инcтаграм: <a className={"myfontABC"}
                                                                  href={"https://www.instagram.com/go_bananas_ru/"}>instagram.com/go_bananas_ru/</a></p>
                        <p className={"unpadding"}>ㅤ</p>
                    </span>
                    </div>
                </div>
                <iframe
                    src="https://yandex.ru/map-widget/v1/?um=constructor%3Ac1e6ba0d7621915c8d1f6823741b917c82eec0c12d373ec3cd224333b379ccd6&amp;source=constructor"
                    width="100%" height="720" frameBorder="0"></iframe>
            </Container>

        </>
    );
};

export default OurContacts;